import React, { useState, useEffect } from 'react'
import { Dialog } from '@progress/kendo-react-dialogs'
import { useTranslation } from 'react-i18next'

import { ButtonHLPure } from '../../pures'
import styles from './dialogDetailsPure.module.css'

/**
 * @author Marissa Vargas
 * @description - Dialog to display a list of details.
 * @typedef {Object} Props
 *  @property {React.ReactNode} children - Custom content or components to render inside the dialog.
 * @property {string} dialogTitle - Dialog heading title
 * @property {function} setCloseDialog - Function to close the dialog.
 * @property {boolean} showBtnPrimary - Show primary button.
 * @property {boolean} showBtnSecondary - Show secondary button.
 * @property {string} labelBtnPrimary - Label for the primary button.
 * @property {string} labelBtnCancel - Label for the cancel button.
 * @property {function} submitDialog - Function to call when the primary button is clicked.
 * @param {Props}
 * @returns {JSX.Element}
 * @example
 * ```jsx
 *  <DialogDetailsPure
      details={[ { detail: 'Company name', value: 'Akubica' }, { detail: 'Total files', value: '5' } ]}
      dialogTitle={'Detalles'}
      setCloseDialog={() => setShowDialog(false)}
    />
 * ```
 */
function DialogDetailsPure({ children, dialogTitle, setCloseDialog, showBtnPrimary, showBtnSecondary, labelBtnPrimary, labelBtnCancel, submitDialog }) {
  const { t } = useTranslation()

  const [currentSystem, setCurrentSystem] = useState('')
  let infodevice = currentSystem.toLowerCase()
  let isMobile = infodevice.includes('android')
  isMobile = isMobile || infodevice.includes('iphone')
  isMobile = isMobile || infodevice.includes('ipad')
  isMobile = isMobile || infodevice.includes('mobile')

  const isTouchScreendevice = () =>
    'ontouchstart' in window || navigator.maxTouchPoints
  if (isTouchScreendevice()) isMobile = true
  useEffect(() => {
    setCurrentSystem(navigator.userAgent)
  }, [])

  let widthDialog = isMobile ? 300 : 400

  return (
    <Dialog title={dialogTitle} onClose={setCloseDialog} className={styles.dialog} width={widthDialog} height={'auto'} >
      <div className={styles.wrapper}>
        {children}
        <div className={styles.btnContainer}>
          {showBtnSecondary && (
            <ButtonHLPure
              primary={false}
              onClickBtn={setCloseDialog}
              nameBtn={labelBtnCancel || t('button.close')}
            />
          )
          }
          {showBtnPrimary && (
            <ButtonHLPure
              primary={true}
              onClickBtn={submitDialog}
              nameBtn={labelBtnPrimary || t('button.accept')}
            />
          )
          }
        </div>
      </div>
    </Dialog>
  )
}

export default DialogDetailsPure
